// Shared visual language for the flow editor chrome — the left rail, the side
// menu, and the node edit panels. Same periwinkle accent / ink / muted text and
// soft layered elevation as the flow-canvas nodes, so every surface reads as
// one system.

export const UI = {
    accent: "#6366F1",
    ink: "#1E293B",
    muted: "#64748B",
    surface: "#FFFFFF",
    danger: "#DC2626",
    width: 52, // left-rail width
    shadow: "0 1px 2px rgba(16, 24, 40, 0.06), 0 10px 30px -10px rgba(16, 24, 40, 0.22)",
};

export const rgba = (hex, alpha) => {
    const n = parseInt(hex.replace("#", ""), 16);
    return `rgba(${(n >> 16) & 255}, ${(n >> 8) & 255}, ${n & 255}, ${alpha})`;
};
